<!-- Migrated from legacy/Plus/Plus/venue.shtml (2013 event venue) -->

<template>
  <h4>MCA Forum at Museum of Contemporary Art, Sydney</h4>
  <p>
    Museum of Contemporary Art, Level 6, Terrace Entrance (Circular Quay West Side), The Rocks
    NSW 2000
  </p>
  <img src="/Plus/img/CircularQuayWest.jpg" alt="Museum of Contemporary Art" class="wide" />
  <p>
    Talks took place at the MCA Forum on level 6 of the historic wing of the Museum, via the
    entrance on the Circular Quay side. The networking event that followed was held in the
    adjacent MCA Lounge.
  </p>
  <img src="/Plus/img/MCA-Roof-Top-Venues_2_2.jpg" alt="MCA rooftop venue" class="medium" />
</template>

<style scoped>
h4 {
  font-weight: 600;
  font-size: 1rem;
}
img.wide {
  width: 100%;
  border-radius: 4px;
}
img.medium {
  width: 60%;
  border-radius: 4px;
}
</style>
